import { usePermissionsChecker } from "core/auth/Permissions";
import { useGateways } from "core/gateways-context/index";
import { Permission } from "core/types/permission.enum";

import { useQuery } from "@tanstack/react-query";

enum SystemCacheKeys {
  appConfiguration = "bpm-system-appConfiguration"
}

export const useAppConfiguration = () => {
  const {
    systemApi: { getAppConfig }
  } = useGateways();

  const hasPermissions = usePermissionsChecker();

  return useQuery({
    queryKey: [SystemCacheKeys.appConfiguration],
    queryFn: getAppConfig,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: hasPermissions(Permission.ProsBpmWebAllowed)
  });
};
